import { IFaqCategory } from '../../faq.types'
import { memo, useState } from 'react'
import EditGroupModal from '../Modals/EditGroupModal'
import faqApi from '../../faq.api'
import faqEvents from '../../events/faq.events'
import CreateGroupModal from '../Modals/CreateGroupModal'
import { useNavigate } from 'react-router'
import ActiveStatusTile from '../ActiveStatusTile'
import confirmServiceCtrl from '../../../../../services/ConfirmService/confirmService.ctrl'
import { ITreeGroup } from '../../../../../shared/Tree/tree.types'
import ActionsButtonWithMenu from 'shared/Buttons/ActionsButtonWithMenu'

interface IProps {
  treeGroup: ITreeGroup<IFaqCategory, IFaqCategory['id']>
}

const CategoryTreeRow = (props: IProps) => {
  const navigate = useNavigate()
  const [createGroupModalOPen, setCreateGroupModalOpen] = useState(false)
  const [editModalOpen, setEditModalOpen] = useState(false)

  const handleRemove = () => {
    confirmServiceCtrl
      .requestConfirm({
        description: 'Подтвердите удаление группы',
        type: 'danger',
        title: 'Подтверждение',
      })
      .then((r) => {
        if (r.response === 'confirm') {
          faqApi.deleteCategory(props.treeGroup.data.id).then((r) => {
            if (r.status === 'success') {
              faqEvents.groupRemoved(r.body.id)
            }
          })
        }
      })
  }

  return (
    <>
      {editModalOpen && <EditGroupModal onClose={() => setEditModalOpen(false)} categoryId={props.treeGroup.data.id} />}
      {createGroupModalOPen && (
        <CreateGroupModal onClose={() => setCreateGroupModalOpen(false)} initialParentId={props.treeGroup.id} />
      )}
      <div className='tree-group'>
        <div className='inline-flex-gap' style={{ width: '100%', justifyContent: 'space-between' }}>
          <div className='inline-flex-gap'>
            <p>{props.treeGroup.data.title}</p>
            <ActiveStatusTile active={props.treeGroup.data.active} />
          </div>
          <div
            onClick={(ev) => {
              ev.stopPropagation()
              ev.preventDefault()
            }}
          >
            <ActionsButtonWithMenu>
              <span
                className='options-contextmenu-option'
                onClick={(ev) => {
                  ev.stopPropagation()
                  ev.preventDefault()

                  setEditModalOpen(true)
                }}
              >
                Редактировать
              </span>
              <span
                className='options-contextmenu-option'
                onClick={() => navigate('/admin/knowledge-base/articles/create?parent_id=' + props.treeGroup.data.id)}
              >
                Добавить статью
              </span>
              <span
                className='options-contextmenu-option'
                onClick={(ev) => {
                  ev.stopPropagation()
                  ev.preventDefault()

                  setCreateGroupModalOpen(true)
                }}
              >
                Добавить группу
              </span>
              <span className='options-contextmenu-option' data-danger='true' onClick={handleRemove}>
                Удалить
              </span>
            </ActionsButtonWithMenu>
          </div>
        </div>
      </div>
    </>
  )
}

export default memo(CategoryTreeRow)
